(() => {
 const root=document.getElementById('MainContent');
 if(!root||root.dataset.atelierHomepage!=='true')return;
 const original=Array.from(root.children);
 const picks=original.find(node=>node.querySelector('.personality-picks'));
 const benefits=original.find(node=>node.querySelector('.restored-benefits'));
 const opening=original.find(node=>node.querySelector('.restored-hero'));
 if(!picks||(!benefits&&!opening))return;
 const mobile=window.matchMedia('(max-width:800px)');
 function arrange(){
  if(mobile.matches){
   const after=(benefits||opening).nextElementSibling;
   if(after!==picks)root.insertBefore(picks,after);
  }else{
   original.forEach(node=>root.appendChild(node));
  }
 }
 arrange();
 mobile.addEventListener('change',arrange);
})();
